import { TaskPriority } from 'src/graphql/types/tasks'
import IconPriorityHigh from 'src/icons/IconPriorityHigh'
import IconPriorityLow from 'src/icons/IconPriorityLow'
import IconPriorityMedium from 'src/icons/IconPriorityMedium'

/**
 * Shared mapping from task priority to its Linear-style bar icon, hover label,
 * and text color. Used by both the dashboard task rows and the Tasks page so
 * the priority indicator stays consistent across the app.
 */
export const PRIORITY_CONFIG = {
  [TaskPriority.HIGH]: {
    Icon: IconPriorityHigh,
    label: 'High Priority',
    color: 'text-doubleNickel-error-400',
  },
  [TaskPriority.MEDIUM]: {
    Icon: IconPriorityMedium,
    label: 'Medium Priority',
    color: 'text-doubleNickel-warning-400',
  },
  [TaskPriority.LOW]: {
    Icon: IconPriorityLow,
    label: 'Low Priority',
    color: 'text-doubleNickel-gray-400',
  },
}
